import React from 'react';
import {  FiArrowLeft, FiArrowRight, FiPhone, FiVideo } from 'react-icons/fi'
import { phones } from '../../../../dummy/phones';


const Phones = () => {
    return (
      <React.Fragment>
           <ul>
               {phones.map((call,i)=>{
  
                return (
                  <li key={`call-${i}`} className="group">
                  <div
                    className="px-2 py-3 rounded-xl mx-2 group-hover:bg-green-100 dark:group-hover:bg-green-700/50"
                  >
                    <div
                      className="group relative flex justify-between items-end cursor-pointer"
                    >
                      <div className="flex gap-2">
                       
  
                        {call.group ? (
                           <div className="flex">
                            {call.color && (
                              <div
                                style={{background:call.color}}
                                className="text-white flex items-center justify-center font-medium h-10 w-10 object-contain rounded-full border border-2 border-white"
                              >
                                {call.name.substring(2,0).toUpperCase()}
                              </div>
                            )}
                           {call.avatar && (
                              <img
                              src={call.avatar}
                              className="h-10 w-10 object-contain rounded-full border border-2 border-white"
                            />
                           )}
                            <div
                              className="bg-gray-200 text-green-600 flex items-center justify-center font-medium -ml-3 h-10 w-10 object-contain rounded-full border border-2 border-white"
                            >
                              +2
                            </div>
                          </div>
                        ):(
                          <div>
                            {call.avatar && (
                              <img
                                src={call.avatar}
                                className="h-10 w-10 object-contain"
                              />
                            )}
                            {call.color && (
                              <div
                                style={{background:call.color}}
                                className='text-white flex items-center justify-center font-medium h-10 w-10 object-contain rounded-full border border-2 border-white'
                              >
                                {call.name.substring(2,0).toUpperCase()}
                              </div>
                            )}
                        </div>
                        )}
                        <div>
                          <div
                            className="font-medium dark:group-hover:text-black- dark:text-white text-gray-800"
                          >
                            {call.name}
                          </div>
                          <div className="flex items-center">
                            {call.status=='incoming' && <FiArrowLeft size={21} className="h-5 text-green-500 -ml-2" style={{transform: 'rotate(-45deg)'}} />} 
                            {call.status=='outgoing' && <FiArrowRight  size={21} className="h-5 text-red-500 -ml-2" style={{transform: 'rotate(-45deg)' }} />  }
                            <p className="text-sm text-gray-400">
                              {call.date}...
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{color:call.color}}
                        className="absolute right-0 h-full flex items-center gap-2"
                      >
                        <p className="text-gray-600 text-sm">{call.duration}</p>
                        {call.type=='phone' && <FiPhone size={24} className="fill-green-500 stroke-none" /> }
                        {call.type=='video' && <FiVideo size={24} className="fill-green-500 stroke-none" /> }
                      </div>
                    </div>
                  </div>
                  </li>
                )
               })}
            </ul>
  
      </React.Fragment>
    )
  }
  
export default Phones
